import ReactGA from 'react-ga';
export const init = () =>{
    const GAID = window.aslanUtils && window.aslanUtils.GA?window.aslanUtils.GA:null
    return ReactGA.initialize(GAID);
}
export const logPageView = () => {
    const isAllowed = ReactGA ? true: false;
    if(!isAllowed) this.init();
    return ReactGA.pageview(window.location.pathname + window.location.search);
}